import { ReactNode } from "react";

import { Breadcrumbs, BreadcrumbsItem } from "@components/ui/breadcrumb";
import { Skeleton } from "@components/ui/skeleton";

import { cn } from "../utils/ui";

type PageHeaderProps = {
  title: string;
  description?: ReactNode;
  breadcrumbs?: BreadcrumbsItem[];
  rightContent?: ReactNode;
  isLoading?: boolean;
};

export const PageHeader = ({
  title,
  description,
  breadcrumbs,
  rightContent,
  isLoading,
}: PageHeaderProps) => {
  return (
    <div className={cn("w-full items-start", "lg:flex lg:justify-between")}>
      <div className="flex-grow">
        {isLoading ? (
          <>
            <Skeleton className="h-4 w-1/4" />
            <Skeleton className="h-7 w-3/4" />
            {description && <Skeleton className="h-4 w-2/3" />}
          </>
        ) : (
          <>
            {breadcrumbs && <Breadcrumbs items={breadcrumbs} />}
            <h1 className="text-lg font-bold tracking-[-0.02em]">{title}</h1>
            {description && (
              <p className="text-[13.5px] text-foreground-muted">{description}</p>
            )}
          </>
        )}
      </div>

      {rightContent && <div>{rightContent}</div>}
    </div>
  );
};
